import React from "react";

const Title = () => {
  return (
    <div className="flex flex-col items-center space-y-8 w-full font-title mt-10">
      <div className="w-14 h-[0.1875rem] bg-tertiary"></div>
      <p className="text-2xl md:text-3xl text-gray-800">
        Your Payment Projection
      </p>
    </div>
  );
};

export default Title;
